module.exports = __webpack_public_path__ + "img/hk_feature2.91e6057e.jpg";